export default __webpack_public_path__ + "static/media/transfer.a280222d.svg";